export default "__VITE_ASSET__pzw3$Iob__"